module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMy43Mjc5MiA3LjM2Mzk2Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzMwMzAzMDt9PC9zdHlsZT48L2RlZnM+PGc+PGc+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSI5LjU0NTk0IiB5PSItMS4zMTgwMiIgd2lkdGg9IjEiIGhlaWdodD0iMTAiIHJ4PSIwLjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuNTQ1OTQgLTYuMDI1MTMpIHJvdGF0ZSg0NSkiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjMuMTgxOTgiIHk9Ii0xLjMxODAyIiB3aWR0aD0iMSIgaGVpZ2h0PSIxMCIgcng9IjAuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC44ODkwOSAzLjY4MTk4KSByb3RhdGUoMTM1KSIvPjwvZz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/images/svg/expand.svg
// module id = SVYx
// module chunks = 1